export const normalizeSearchValue = (value) => String(value || "").trim().toLowerCase();

export const getMatchIndexes = ({ source, query }) => {
  if (!query) {
    return [];
  }
  const matches = [];
  let cursor = 0;
  while (cursor < source.length) {
    const foundIndex = source.indexOf(query, cursor);
    if (foundIndex < 0) {
      break;
    }
    matches.push(foundIndex);
    cursor = foundIndex + query.length;
  }
  return matches;
};
